const resource = {
    resource_identifier_in_use: "L'identifiant d'API {{indicator}} est déjà utilisé",
};
export default Object.freeze(resource);
